
import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild, forwardRef, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { CurrencyInputPipe } from '@hub/pipes/CurrencyInput.pipe';
import { FormEventService } from '@hub/services/form-event.service';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';


const noop = () => { };

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormInputComponent),
  multi: true
};

@Component({
  selector: 'fm-input',
  templateUrl: 'form-input.component.html',

  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    // {provide: BaseErrorForm, useExisting: forwardRef(() => FormInputComponent)}],
})
export class FormInputComponent extends BaseErrorForm
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) { super(); }

  @Input() public useCurrencyPipe: boolean = false;
  @Input() public isWholeNumber: boolean = false;
  @Input() public isWholeNumberWithNegative: boolean = false;
  @Input() public type: string;
  @Input() public disabled: boolean = false;
  @Output() onChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('in') public input: ElementRef;

  public tabindex: string;
  @Input('tabindex')
  public set tabind(val: string) {
    this.tabindex = String(val);
  }

  public isFocused: boolean = false;
  public inputType: string;
  private numOfTabs: number = 0;
  private innerValue: any = '';
  private currencyPipe: CurrencyInputPipe = new CurrencyInputPipe();
  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {
    if (this.type) {
      this.inputType = this.type;
    } else {
      this.inputType = 'text';
    }
    this.formEventService.setIndex(parseInt(this.tabindex));

    const elem: HTMLElement = this.el.nativeElement;
    this.renderer.setStyle(elem, 'outline', 'none');
  }

  public ngOnDestroy(): void {
  }

  get value(): any {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.value) {
      this.writeValue(v.trim());
      this.onChangeCallback(v.trim());
    }
  }

  //From ControlValueAccessor interface
  public writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
    if (this.useCurrencyPipe) {
      this.innerValue = this.currencyPipe.transformNoSuffix(value);
    }
  }

  //From ControlValueAccessor interface
  public registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  public registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onFocus(value) {
    if(this.useCurrencyPipe) {
      this.isFocused = true;
      this.value = this.currencyPipe.parse(value);
    }
  } 

  onBlur(value) {
    if (this.useCurrencyPipe) {
      this.isFocused = true;
      this.innerValue = this.currencyPipe.transform(value, 0);
    }
    this.onTouchedCallback();
  }

  onChange(newValue: string) {
    if (newValue !== this.innerValue) {
      this.writeValue(newValue.trim());
    }
    this.onChanged.emit(newValue.trim());
  }
  
  isWholeNumberCheck(event) {
    var keycode = event.keyCode;
    var negativeCheck = this.isWholeNumberWithNegative ? keycode == 45 : false;
    if((negativeCheck) || (keycode >= 48 && keycode <= 57)) {
      return true;
    }
    return false;
  }
}